import { makeAutoObservable } from 'mobx'
import enter from 'src/assets/images/common/enter.svg'
import massCreated from 'src/assets/images/common/massCreated.svg'
import archive from 'src/assets/images/common/pack_in.svg'
import fullSubsidy from 'src/assets/images/financialSource/typeSubsidy.svg'
import {
  isAdmin,
  isAdministration,
  isDealer,
} from '../../../../services/AccountService'
import {
  addRequestsToArchive,
  assignDealer,
  bulkAccept,
  resetToCreatedGroup,
  updateFinancialSourceGroup,
} from '../../../../services/ApiService'
import {
  notifyError,
  notifySuccess,
} from '../../../../services/ToastifyService/ToastifyService'
import checkboxStore from '../../../../stores/CheckboxStore'
import requestsManagementStore from '../../../../stores/RequestsManagementStore'
import { gState } from '../../../../utils/controllers/GlobalStateController'
import {
  closeModalFn,
  openModalFn,
} from '../../../../utils/controllers/ModalController'
import { getComp } from '../../../../utils/utils/DI'
import getNoun from '../../../../utils/utils/getNoun'
import { newAssignDealerDrawerStore } from '../MassOperationDrawer/NewAssignDealerDrawerStore'
class RequestsTableStore {
  data = []
  isTableRowSelected = null
  selected = []
  firstItem = null
  newDealer = null
  massOperation = false
  actionType = ''
  isAssignDealerDrawerOpen = false
  isMassChangeTypeSubsidyOpen = false
  isMassChangeStatusDrawerOpen = false
  selectAllMode = false
  onCustomSelect = null
  customSelectAll = null
  customClearAllSelect = null
  firstRowStatus = null
  firstRowReportStatus = null

  constructor() {
    this.territoryStore = getComp('TerritoryStore')
    this.dealersStore = getComp('DealersStore')
    this.ordersStore = getComp('OrdersStore')
    this.userStore = getComp('UserInfoStore')

    makeAutoObservable(this)
  }

  get selectedOrders() {
    if (checkboxStore.selectedIds.length && !this.selected.length) {
      return this.data.filter((el) =>
        checkboxStore.selectedIds.some((id) => id === el.id),
      )
    }
    return this.data.filter((el) => this.selected.some((id) => id === el.id))
  }

  setOnCustomSelect = (
    onCustomSelect,
    customSelectAll,
    customClearAllSelect,
  ) => {
    this.onCustomSelect = onCustomSelect
    this.customSelectAll = customSelectAll
    this.customClearAllSelect = customClearAllSelect
  }

  outlineTrue = (row) => {
    this.data.map((item) => {
      if (item.id === row.id) {
        item.outline = true
      } else {
        item.outline = false
      }
      return item
    })
  }

  closeMassOperation = () => {
    this.massOperation = false
  }

  openMassOperation = () => {
    this.massOperation = true
  }

  addServiceProps = (collection = this.data) => {
    this.data = collection.map((row) => {
      if (this.selected.includes(row.id) && !isDealer()) {
        row.checked = true
      } else {
        row.checked = false
      }
      if (!isDealer()) {
        if (this.selectAllMode || [1, 2, 4].includes(row.status)) {
          row.showChecbox = true
        } else {
          row.showChecbox = false
        }
      } else if (isDealer() && this.selectAllMode) {
        row.showChecbox = true
      }

      row.outline = false

      return row
    })

    this.firstRowStatus = this.data[0] ? this.data[0].status : null
    this.firstRowReportStatus = this.data[0] ? this.data[0].reportStatus : null

    if (!this.selectAllMode && this.firstItem) {
      const checboxesIds = this.data
        .filter((item) => item.status === this.firstItem.status)
        .map((item) => item.id)

      checkboxStore.setAllIds(checboxesIds, true)
    } else {
      this.updateCheckboxData()
    }
  }

  updateCheckboxData = () => {
    const checkboxesSelected =
      checkboxStore.selectedIds.length &&
      this.data.some((el) => checkboxStore.selectedIds.includes(el.id))

    if (!isDealer() && !isAdministration()) {
      const checboxesIds = this.selectAllMode
        ? this.data.map((item) => item.id)
        : this.data
            .filter((item) =>
              checkboxesSelected
                ? item.status === checkboxStore.status
                : [1, 2, 4].includes(item.status),
            )
            .map((item) => item.id)

      checkboxesSelected
        ? checkboxStore.updateSelectedIds(
            checboxesIds,
            checkboxStore.selectedIds,
          )
        : checkboxStore.setAllIds(checboxesIds, true)
    } else if (isAdministration()) {
      const checboxesIds = this.data
        .filter((item) => item.status === 1)
        .map((item) => item.id)

      checkboxesSelected
        ? checkboxStore.updateSelectedIds(
            checboxesIds,
            checkboxStore.selectedIds,
          )
        : checkboxStore.setAllIds(checboxesIds, true)
    } else {
      const checboxesIds = checkboxesSelected
        ? this.data
            .filter((item) => item.status === checkboxStore.status)
            .map((item) => item.id)
        : this.data.map((item) => item.id)

      checkboxesSelected
        ? checkboxStore.updateSelectedIds(
            checboxesIds,
            checkboxStore.selectedIds,
          )
        : checkboxStore.setAllIds(checboxesIds, true)
    }
  }

  toggleSelection = (row) => {
    if (this.onCustomSelect) {
      this.onCustomSelect(row)
    }

    if (checkboxStore.status) {
      const updatedCheckboxes = this.data
        .filter((item) => item.status === checkboxStore.status)
        .map((item) => item.id)

      if (
        updatedCheckboxes.length !== checkboxStore.allIds.length &&
        !this.selectAllMode
      ) {
        checkboxStore.updateSelectedIds(updatedCheckboxes, [row.id])
      }
    } else if (!checkboxStore.selectedIds.length) {
      this.updateCheckboxData()
    }
  }

  // проверяет если все регионы в белом списке
  someFullDotation = () => {
    const selectedRow = this.data.filter((row) =>
      checkboxStore.selectedIds.includes(row.id),
    )

    return selectedRow.some((row) => {
      const districts =
        this.territoryStore.territories[row.territory]?.Territory.Districts
      const district =
        districts?.find((district) => district.Name === row.district) ?? []

      if (!district) return false

      const locality = district?.Localities?.find(
        (locality) => locality.Name === row.locality,
      )

      if (!locality) return false

      return locality.AllowedFinancialSourceIds.every((id) => id !== 1)
    })
  }

  // проверяет если хоть один в белом списке
  someNewFullDotation = () => {
    const selectedRow = this.data.filter((row) =>
      checkboxStore.selectedIds.includes(row.id),
    )

    const checkIsSomeFullDotation = (locality) => {
      const el = locality.AllowedFinancialSourceIds.find((id) => id === 1)

      return el
    }

    const result = selectedRow.some((row) => {
      const districts =
        this.territoryStore.territories[row.territory]?.Territory.Districts
      const district =
        districts?.find((district) => district.Name === row.district) ?? []

      if (!district) return false

      const locality = district?.Localities?.find(
        (locality) => locality.Name === row.locality,
      )

      if (!locality) return false

      return checkIsSomeFullDotation(locality)
    })

    return result
  }

  isSomeChecked = () => {
    return this.data.some((item) => item.checked)
  }

  allSelectedCheckbox = (isReport = false, isRequestsAndAdmin = false) => {
    const firstEl =
      isDealer() || this.selectAllMode
        ? this.data[0]
        : this.data.find((el) => [1, 2, 4].includes(el.status))

    if (!isReport && !isAdministration()) {
      if (checkboxStore.isAllChecked) {
        const updatedCheckboxes =
          isDealer() || this.selectAllMode
            ? this.data.map((el) => el.id)
            : this.data
                .filter((el) => [1, 2, 4].includes(el.status))
                .map((el) => el.id)

        checkboxStore.setAllIds(updatedCheckboxes)
      } else {
        const status = checkboxStore.status ?? firstEl?.status
        const updatedCheckboxes = this.data
          .filter((el) => el.status === status)
          .map((el) => el.id)

        if (!this.selectAllMode) {
          checkboxStore.updateSelectedIds(
            updatedCheckboxes,
            checkboxStore.selectedIds,
          )
        }
      }
    }

    const isFirstStatus = checkboxStore.status === 1 || firstEl?.status === 1

    if (
      isRequestsAndAdmin &&
      isFirstStatus &&
      !checkboxStore.isForbiddenPaymentType
    ) {
      const wrongIdsForArchive = this.data.filter(
        (el) => el.status === 1 && [1, 2, 3, 5].includes(el.financialSourceId),
      )

      checkboxStore.setForbiddenPaymentCount('set', wrongIdsForArchive.length)
    }
    checkboxStore.toggleAllSelection(firstEl?.status, firstEl?.reportStatus)
  }

  isIndeterminate = () => {
    return this.data.some((item) => item.checked) && !this.isAllSelected()
  }

  isAllSelected = () => {
    const elements = this.firstItem
      ? this.data.filter((item) => item.status === this.firstItem.status)
      : this.data
    return !elements.some((item) => !item.checked)
  }

  getIdSelectedOrders = () => {
    this.selected = this.data
      .filter((item) => item.checked)
      .map((item) => item.id)
    this.isTableRowSelected = this.selected.length
  }

  clearSelectOrders = () => {
    this.firstItem = null
    this.selected = []
    this.addServiceProps(this.data)
  }

  updateOrders = (newOrders, callback) => {
    this.data = this.data.map((item) => {
      const updatedOrder = newOrders.find((order) => order.id === item.id)
      return updatedOrder ? { ...item, ...updatedOrder } : item
    })
    if (newOrders.length)
      requestsManagementStore.ordersStore.updateOrderItems(newOrders)

    if (callback) {
      callback()
    }
  }

  getActionTabs = () => {
    return [
      {
        name: gState['intl'].formatMessage({ id: 'Назначить дилера' }),
        action: () => newAssignDealerDrawerStore.setIsOpen(true),
        icon: enter,
        isActive: isAdmin(),
        status: [1, 2],
      },
      {
        name: gState['intl'].formatMessage({
          id: 'Перевести в статус "Создана"',
        }),
        action: this.toggleMassChangeStatusDrawer,
        icon: massCreated,
        isActive: isAdmin(),
        forStatus: true,
        status: [2, 4],
      },

      {
        name: gState['intl'].formatMessage({ id: 'Изменить тип оплаты' }),
        action: this.toggleMassChangeTypeSubsidy,
        icon: fullSubsidy,
        isActive: isAdmin() || isAdministration(),
        status: [1, 2],
      },
      {
        name: gState['intl'].formatMessage({ id: 'Принять заявки' }),
        action: this.bulkAccept,
        isActive: isDealer(),
      },
      {
        name: 'Добавить в архив',
        action: (reloadFn) => this.sendToArchive(reloadFn),
        isActive: isAdmin(),
        status: [1],
        icon: archive,
      },
    ]
  }

  toggleAssignDealerDrawer = () => {
    if (this.massOperation) {
      this.closeMassOperation()
    } else {
      this.newDealer = null
      this.openMassOperation()
      this.actionType = 'assignToDealer'
    }
  }

  toggleMassChangeStatusDrawer = () => {
    if (this.massOperation) {
      this.closeMassOperation()
    } else {
      this.openMassOperation()
      this.actionType = 'changeStatus'
    }
  }

  toggleMassChangeTypeSubsidy = () => {
    if (this.massOperation) {
      this.closeMassOperation()
    } else {
      this.openMassOperation()
      this.actionType = 'changeTypeSubsidy'
    }
  }

  containsSubstring(errorString, substring) {
    return errorString.includes(substring)
  }

  bulkAccept = async (ids) => {
    openModalFn['progress-backdrop']()

    return new Promise((resolve, reject) =>
      fetch(`${window.location.origin}/version.json`)
        .then((res) => res.json())
        .then((version) => {
          bulkAccept({
            orderIdList: ids,
            appVersion: version.version,
          })
            .then((res) => {
              if (res) {
                this.updateOrders(res)
                this.selected?.forEach((order) =>
                  this.ordersStore.updateOrder(order),
                )

                this.clearSelectOrders()
              }
              closeModalFn['progress-backdrop']()
              resolve()
            })
            .catch(() => {
              closeModalFn['progress-backdrop']()
              reject()
            })
        }),
    )
  }

  addToArchive = (reloadFn) => {
    const count = checkboxStore.selectedIds.length
    openModalFn['progress-backdrop']()
    addRequestsToArchive({
      orderIds: [...checkboxStore.selectedIds],
    })
      .then((res) => {
        this.ordersStore.reLoad()
        setTimeout(() => {
          this.clearSelectOrders()

          // решить нужно уведомление или нет
          const message = gState['intl'].formatMessage(
            {
              id: '{size} {sizeNoun} {sizeNounAction} в архив',
              defaultMessage: `{size} {sizeNoun} {sizeNounAction} в архив`,
            },
            {
              size: count,
              sizeNoun: getNoun(count, 'заявка', 'заявки', 'заявок'),
              sizeNounAction: getNoun(
                count,
                'перенесена',
                'перенесены',
                'перенесены',
              ),
            },
          )

          notifySuccess(message)

          reloadFn()
          closeModalFn['progress-backdrop']()
        }, 100)
      })
      .catch(() => {
        closeModalFn['progress-backdrop']()
      })
  }

  sendToArchive = (reloadFn) => {
    if (
      checkboxStore?.isForbiddenPaymentType ||
      checkboxStore.forbiddenPaymentCounts
    ) {
      notifyError('Запрещен для выбранного типа оплаты')
    } else {
      openModalFn['transaction-confirmation']?.({
        text1: `Подтвердить перемещение `,
        value1: `${checkboxStore?.selectedIds.length}`,
        text2: getNoun(
          checkboxStore?.selectedIds.length,
          'заявки в Архив?',
          'заявок в Архив?',
          'заявок в Архив?',
        ),
        action: () => this.addToArchive(reloadFn),
        processText: `Выполняется перемещение ${
          checkboxStore?.selectedIds.length
        } ${getNoun(
          checkboxStore?.selectedIds.length,
          'заявки',
          'заявок',
          'заявок',
        )} в Архив`,
      })
    }
  }

  assignDealer = (ordersStore) => {
    const size = this.selected.length
      ? this.selected.length
      : checkboxStore.selectedIds.length

    const orderIds = this.selected.length
      ? this.selected
      : checkboxStore.selectedIds

    openModalFn['progress-backdrop']()
    fetch(`${window.location.origin}/version.json`)
      .then((res) => res.json())
      .then((version) => {
        assignDealer({
          dealerId: this.dealersStore.getDealer(this.newDealer)?.subjectId,
          orderIds,
          appVersion: version.version,
        })
          .then((res) => {
            const notification = () => {
              const dealerName = this.dealersStore.getDealer(
                this.newDealer,
              ).displayName
              closeModalFn['progress-backdrop']()
              const message = gState['intl'].formatMessage(
                {
                  id: '{size} {sizeNoun} {sizeNounAction} на дилера {dealer}',
                  defaultMessage: `{size} {sizeNoun} {sizeNounAction} на дилера {dealer}`,
                },
                {
                  size: size,
                  sizeNoun: getNoun(size, 'заявка', 'заявки', 'заявок'),
                  sizeNounAction: getNoun(
                    size,
                    'назначена',
                    'назначены',
                    'назначены',
                  ),
                  dealer: dealerName,
                },
              )
              notifySuccess(message)
            }
            this.updateOrders(res, notification)
            checkboxStore.resetAll()
            ordersStore.setData(this.data)
            this.toggleAssignDealerDrawer()
            this.clearSelectOrders()
          })
          .catch((err) => {
            closeModalFn['progress-backdrop']()
          })
          .finally(() => {
            closeModalFn['modal-confirmation-submit-dialog']()
            closeModalFn['progress-backdrop']()
          })
      })
  }

  massChangeStatus = (ids, ordersStore) => {
    openModalFn['progress-backdrop']()
    fetch(`${window.location.origin}/version.json`)
      .then((res) => res.json())
      .then((version) => {
        resetToCreatedGroup({ orderIds: [...ids], appVersion: version.version })
          .then((res) => {
            if (res) {
              this.updateOrders(
                res,
                notifySuccess('Заявки переведены в статус "Создана"'),
              )

              ordersStore.setData(this.data)
              this.toggleMassChangeStatusDrawer()
              this.clearSelectOrders()
            }
          })
          .catch(() => {
            this.toggleMassChangeStatusDrawer()
          })
          .finally(() => {
            closeModalFn['progress-backdrop']()
          })
      })
  }

  massChangeTypeSubsidy = (ids, financialSourceId, ordersStore) => {
    openModalFn['progress-backdrop']()
    fetch(`${window.location.origin}/version.json`)
      .then((res) => res.json())
      .then((version) => {
        updateFinancialSourceGroup({
          orderIds: [...ids],
          financialSourceId: financialSourceId,
          appVersion: version.version,
        })
          .then((res) => {
            if (res) {
              this.updateOrders(
                res,
                notifySuccess(
                  ids.length > 1
                    ? 'Тип оплаты заявок обновлен'
                    : 'Тип оплаты заявки обновлен',
                ),
              )
              ordersStore.setData(this.data)
              this.toggleMassChangeTypeSubsidy()
              this.clearSelectOrders()
              checkboxStore.resetAll()
            }
          })
          .catch(() => {
            closeModalFn['progress-backdrop']()
            this.toggleMassChangeTypeSubsidy()
          })
          .finally(() => {
            closeModalFn['progress-backdrop']()
          })
      })
  }

  flagResonInstallation = (ordersStore) => {
    return ordersStore.collection
      .filter((item) => [...this.selected].includes(item.id))
      .some((item) => item.reasonId === 1 || item.reasonId === 2)
  }

  logout = () => {
    this.data = []
  }
}

const store = new RequestsTableStore()
export default store
